<template>
  <div class="login">
    <v-container fill-height>
      <v-layout row xs12 fill-height justify-center align-center>
        <v-flex xs12 md3>
          <v-card flat tile class="grey darken-1 flexcard" height="400">

              <v-card-title>
                <img :src="ecologo">
              </v-card-title>

              <v-card-text class="grow">
                <v-form v-model="validform">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field label="Username" color="amber accent-3" :rules="[validation_rules.usernamelen]" v-model="username" :disabled="login_busy"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Password" color="amber accent-3" type="password" v-model="password" :disabled="login_busy"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row>
                        <v-spacer></v-spacer>
                        <v-flex shrink text-xs-center>
                          <v-btn depressed small color="amber accent-4" :disabled="!validform" v-on:click="login_submit" :loading="login_busy">
                            Login
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <div class="red--text mt-3 body-1">{{ login_error }}</div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>

              <v-card-text class="">
                <span class="caption darkgrey--text font-weight-light font-italic">
                  By logging in you agree to be bound by our terms and conditions.
                </span>
              </v-card-text>

          </v-card>
        </v-flex>
        <v-flex hidden-sm-and-down xs6>
          <v-card class="loginsplash white--text" flat tile height="400">
            <p class="pt-5 pl-3">
              <span class="display-1 font-weight-light">Welcome to</span>
              <span class="display-1 font-weight-bold pl-2">Eco Hosted PABX</span>
            </p>
            <p class="pl-3">
              <span class="subheading font-weight-light font-italic">Log in to access your account</span>
            </p>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { m_api_login } from '../js/api.js'
export default {
  name: 'login',
  mixins: [
    m_api_login
  ],
  data() {
    return {
      ecologo: require('../assets/ecologo-small.png'),
      username: '',
      password: '',
      validform: true,
      validation_rules: {
        usernamelen: function (value) {
          if (value.length < 1) {
            return 'Username required'
          }
          if (value.length > 20) {
            return 'Max 20 characters allowed'
          }

          return true
        }
      },
      loading: false,
      login_error: ''
    }
  },
  methods: {
    login_submit: function() {
      this.login_error = ''
      this.loading = true
      var that = this
      this.api_login(this.username, this.password).then(function() {
        // that.$socket.emit('login',that.$store.state.authtoken)

        // that.loading = false
      }).catch(e => {
        that.loading = false
        if (e.response) {
          if (e.response.status === 401) {
            that.login_error = 'Authentication failure. Please try again.'
          } else {
            that.login_error = e.message
          }
        } else {
          if (typeof(e) === 'string') {
            that.login_error = e
          } else {
            that.login_error = 'Timeout waiting for server response.'
          }
        }
      })
    }
  },
  computed: {
    ws_logging_in: function () {
      return this.$store.state.ws_login_status == 3
    },
    admin_acclist_loaded: function () {
      return this.$store.state.admin_acclist_loaded
    },
    login_busy: function () {
      if (this.loading) {
        return true
      }
      if (this.ws_logging_in) {
        return true
      }

      return false
    }
  },
  /*
  beforeCreate: function () {
    delete this.$authtoken
  }, */
  beforeMount: function () {
    this.$store.commit('set_authtoken',null)
    this.$store.commit('set_admin_acclist',[])
    this.$store.commit('set_admin_selacc',null)
    this.$store.commit('set_ws_login_status',0)
  }
}
</script>

<style>
.login {
  background-image: url('../assets/login-bg.jpg');
  background-repeat: repeat;
  height: 100vh;
}
.loginsplash {
  background-image: url('../assets/login-splash.jpg');
}
.flexcard {
  display: flex;
  flex-direction: column;
}
.v-btn__content {
  padding-top: 1px;
}
</style>
